<template>
  <div>
    <div v-show="fakeLoading" class="fake-loader">
      <el-spinner>
        )
      </el-spinner>
    </div>
    <div v-show="!fakeLoading">
      <editor
          api-key="j9tnhmq9a0ljeikssk54m8x9imkctw70q7zans16v1m6vw04"
          :init="{
        directionality: 'rtl',
        height: 400,
        plugins: 'directionality',
        toolbar: 'ltr rtl',
        mobile: {
          menubar: true
        },
        font_formats: 'IranSans=IRANSans; IranNastaliq=IranNastaliq; ANic=ANic; Aghigh=Aghigh; Aviny=Aviny;Bahman=Bahman; Chehr=Chehr; Cinema=Cinema; DimaDanesh=DimaDanesh; DimaEsfahan=DimaEsfahan; DimaKoodak=DimaKoodak; DimaMoalem=DimaMoalem; DimaNastalighTahriri=DimaNastalighTahriri; Dimasport=Dimasport; Fatemefaramarzian=Fatemefaramarzian; Kalame=Kalame; Ravi=Ravi; Daftar=Daftar;   Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;'
      }"
          v-model="content"
      />
    </div>
    <NumberInput @changeConfig="changeConfig" :element="element"
                 :zIndex="element.config.zIndex ? element.config.zIndex : ''"/>
    <div style="margin-top: 12px;text-align: center">
      <el-button type="primary" @click="changeTextConfig">
        ثبت
      </el-button>
    </div>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import NumberInput from "@/components/Inputs/NumberInput";

export default {
  name: "TextWidgetConfig",
  components: {
    NumberInput,
    'editor': Editor
  },
  props: {
    element: {}
  },
  data() {
    return {
      content: '',
      numberInputData: '',
      fakeLoading: false
    }
  },
  mounted() {
    if (this.element.config.content) {
      this.content = this.element.config.content
    }
  },
  created() {

    this.fakeLoading = true;
    setTimeout(() => this.fakeLoading = false, 5000)

  },
  methods: {
    changeConfig(data) {
      this.numberInputData = data
    },
    changeTextConfig() {
      this.$emit('changeConfig', {
        props: 'content',
        value: this.content,
        id: this.element.id
      })
      if (this.numberInputData)
        this.$emit('changeConfig', this.numberInputData);

    }
  }
}
</script>

<style scoped>
.fake-loader {
  height: 350px;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
